import request from "@/utils/request";

// 获取首页数据
export function getHomeData(data) {
    return request({
        url: "/match/match/getByDomain",
        method: "post",
        data
    });
}

// 获取学校信息
export function getSchoolData(data) {
    return request({
        url: "/match/match/getSchoolByDomain",
        method: "post",
        data
    });
}

// 获取赛段
export function getTimerShaft(data) {
    return request({
        url: "/match/timerShaft/list",
        method: "post",
        data
    });
}

// 获取时间
export function getTimer(params) {
    return request({
        url: "/support/time/getCurrentTime",
        method: "get"
    });
}

//获取赛事锦囊
export function getMatchVideo(data){
    return request({
        url:'/match/matchVideo/list',
        method:'post',
        data
    })
}

//下载
export function getDownLoad(data){
    return request({
        url:'support/download/download',
        method:'post',
        data
    })
}


//更改下载名称
export function downName(data){
    return request({
        url:`/support/download/download`,
        method:'get',
        params:data
    })
}


// WEBPACK FOOTER //
// ./src/api/home.js